namespace TabAurous.OMS {
    export interface DepartmentMasterRow {
        DeptId?: number;
        DeptCode?: string;
        DeptName?: string;
        DepartmentTypeId?: number;
        ParentDeptId?: number;
        ItemTypeId?: string;
        ProcessDetails?: number[];
        CompanyId?: number;
        Narration?: string;
        UserId?: number;
    }

    export namespace DepartmentMasterRow {
        export const idProperty = 'DeptId';
        export const nameProperty = 'DeptCode';
        export const localTextPrefix = 'OMS.DepartmentMaster';
        export const lookupKey = 'OMS.Department';

        export function getLookup(): Q.Lookup<DepartmentMasterRow> {
            return Q.getLookup<DepartmentMasterRow>('OMS.Department');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            DeptId = "DeptId",
            DeptCode = "DeptCode",
            DeptName = "DeptName",
            DepartmentTypeId = "DepartmentTypeId",
            ParentDeptId = "ParentDeptId",
            ItemTypeId = "ItemTypeId",
            ProcessDetails = "ProcessDetails",
            CompanyId = "CompanyId",
            Narration = "Narration",
            UserId = "UserId"
        }
    }
}
